// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__Tw30H","vLegacy":"SelectSecondary_vLegacy__k3_WZ","error":"SelectSecondary_error__3g20J","disabled":"SelectSecondary_disabled__2LC8v"};